<template>
  <div class="container">
    <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="10" :sm="10">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间">
                <month-select @change="monthChange"></month-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <a-button type="primary" style="margin: 0 10px" icon="download" @click="handleExportXls('月报表.xls')">导出</a-button>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-radio-group name="dataType" v-model="factorCategory" @change="dataChartChange">
                <a-radio value="11">水质</a-radio>
                <a-radio value="12">过程</a-radio>
                <a-radio value="13">电力</a-radio>
              </a-radio-group>
            </a-col>
            <a-col :md="24" :sm="24" style="margin-top: 10px" v-if="factorCategory == '13'">
              <a-radio-group v-model="selectSearch" @change="selectChange">
                <a-radio v-for="(item, index) in searchData" :key="index" :value="item.code">{{ item.name }}</a-radio>
              </a-radio-group>
            </a-col>
            <a-col :md="24" :sm="24" style="margin: 10px 0">
              <a-checkbox-group
                v-model="selectCol"
                name="checkboxgroup"
                :options="options"
                @change="onChange"
              />
            </a-col>
          </a-row>
        </a-form>
    </div>
    <div>
      <a-table
        id="tb"
        ref="table"
        size="middle"
        :scroll="scroll"
        bordered
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
      ></a-table>
    </div>
  </div>
</template>
<script>
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import { getAction } from '@/api/manage'
import monthSelect from '@/components/date/monthSelect'
import {
  downloadFile
} from '@/api/manage'
export default {
  name: 'St21Cn2061ReportMonth',
  data() {
    return {
      siteOnly: true,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      options: [],
      scroll:false,
      factorCategory: '11',
      queryParam: {},
      selectSearch: '',
      searchData: [],
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      cols: [
        {
          title: '监测时间',
          align: 'center',
          width: '200px',
          dataIndex: 'dateStr',
          colName: 'data_time',
        },

      ],
      loading: false,
    }
  },
  components: { monthSelect },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId(value) {
      var ids = this.getTreeCurrentId()
      if (ids[0] == '1') {
        this.queryParam.id = ids[1]
        this.getSearchData(ids[1])
      }
    },
  },
  methods: {
    handleExportXls(s) {
      downloadFile(s, "/st53/cn2011/report/export", this.queryParam)
    },
    dataChartChange(e) {
      this.factorCategory = e.target.value
      if (this.factorCategory == '13') {
        this.getSearchData()
      } else {
        this.loadData()
      }
    },
     selectChange(e) {
      this.selectSearch = e.target.value
      this.loadData(this.selectSearch)
    },
    // 查询
    searchQuery() {
      this.loadData(this.selectSearch)
    },
    getSearchData(id) {
      let that = this
      getAction('/st53/cn2011/electricity', { siteId: id || window.sessionStorage.getItem('siteId') }).then((res) => {
        if (res.success) {
          that.searchData = res.result
          if (res.result.length > 0) {
            that.selectSearch = res.result[0].code
          } else {
            that.selectSearch = null
          }
          that.loadData(that.selectSearch)

        }
      })
    },
    // 月变化
    monthChange(value) {
      this.queryParam.quantum = value
      console.log('月变化', value)
    },
    // 列变化
    onChange(checkedValues) {
      this.columns = [...this.cols]
      checkedValues.forEach((item, i) => {
        this.allColumns.forEach((element) => {
          if (item == element.id) {
            this.columns.push(element)
          }
        })
      })
    },
    // 水质标准
    renderStatus(record) {
      if (record.currentStandard) {
        return (
          <span class="statusText" style={'background-color:' + record.currentStandard.color}>
            {record.currentStandard.title}
          </span>
        )
      } else {
        return ''
      }
    },
    // 渲染列
    renderCol(code, text, record) {
      let data = record.dataCodeMap[code] || { value: '' }
      if (data.status == '2') {
        return (
          <span class="redText" title={'原始数据： ' + data.raw}>
            {data.value}
            <a-icon type="arrow-down" style="float:right" />
          </span>
        )
      } else if (data.status == '3') {
        return (
          <span class="redText" title={'原始数据： ' + data.raw}>
            {data.value}
            <a-icon type="arrow-up" style="float:right" />
          </span>
        )
      } else {
        return <span title={'原始数据： ' + data.raw}>{data.value}</span>
      }
    },
    // 加载表格
    loadData(selectSearch) {

      let that = this
      if (this.factorCategory == '13') {
        if (!selectSearch) {
          that.dataSource = []
          that.allColumns = []
          that.selectCol = []
          that.options = []
          that.columns = [...that.cols]
          return
        }
        this.queryParam = {
          quantum: this.queryParam.quantum,
          id: this.queryParam.id,
          type: 3,
          factorCategory: this.factorCategory,
          factorCode: selectSearch,
        }
      } else {
        this.queryParam = {
          quantum: this.queryParam.quantum,
          id: this.queryParam.id,
          type: 3,
          factorCategory: this.factorCategory,
        }
      }
      this.loading = true
      getAction('/st53/cn2011/report', this.queryParam).then((res) => {
        if (res.success) {
          that.dataSource = res.result.data
          that.allColumns = [...that.cols]
          that.selectCol = []
          that.options = []
          res.result.factors.forEach((element) => {
            that.options.push({
              label: element.title,
              value: element.code,
            })
            that.selectCol.push(element.code)
            that.allColumns.push({
              id: element.code,
              title: element.title,
              align: 'center',
              width: 250,
              children: [
                {
                  title: element.unitName,
                  align: 'center',
                  width: 200,
                  dataIndex: element.code,
                  customRender: (text, record, index) => {
                    return that.renderCol(element.code, text, record)
                  },
                },
              ],
            })
          })

          that.columns = [...that.allColumns]
          if(that.options.length>15){
            that.scroll={x:3000}
          }else{
            that.scroll=false
          }
        } else {
          this.$message.warning('系统异常=>' + res.message)
        }
        this.loading = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  padding: 10px 20px 30px;
  box-sizing: border-box;
}
.redText {
  color: red;
  cursor: pointer;
}
.statusText {
  color: #000;
  padding: 3px 10px;
  border-radius: 10px;
}
</style>
